import { Search } from 'lucide-react';
import { useState } from 'react';
import { glossaire } from '../mock';

const Glossaire = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredGlossaire = glossaire.filter((item) =>
    item.terme.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.definition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Regrouper par lettre
  const groupedGlossaire = filteredGlossaire.reduce((acc, item) => {
    const firstLetter = item.terme[0].toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(item);
    return acc;
  }, {});

  const sortedLetters = Object.keys(groupedGlossaire).sort();

  return (
    <main className="glossaire-container">
      <div className="glossaire-header">
        <h1 className="page-title">Glossaire de Lithothérapie</h1>
        <p className="page-subtitle">
          Découvrez les termes essentiels de la lithothérapie et de la minéralogie. Un lexique pour mieux comprendre le monde des pierres naturelles.
        </p>
      </div>

      {/* Search Bar */}
      <div className="search-section">
        <div className="search-wrapper">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Rechercher un terme..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <p className="results-count">
          {filteredGlossaire.length} {filteredGlossaire.length === 1 ? 'terme trouvé' : 'termes trouvés'}
        </p>
      </div>

      {/* Glossaire Content */}
      {filteredGlossaire.length > 0 ? (
        <div className="glossaire-content">
          {sortedLetters.map((letter) => (
            <section key={letter} className="letter-section">
              <h2 className="letter-heading">{letter}</h2>
              <div className="terms-list">
                {groupedGlossaire[letter].map((item, index) => (
                  <div key={index} className="term-item">
                    <h3 className="term-title">{item.terme}</h3>
                    <p className="term-definition">{item.definition}</p>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <p>Aucun terme ne correspond à votre recherche.</p>
        </div>
      )}

      <style jsx>{`
        .glossaire-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 3rem 2rem;
          min-height: 80vh;
        }

        .glossaire-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .page-title {
          font-size: 3rem;
          color: #1a365d;
          margin-bottom: 1rem;
          font-weight: 600;
        }

        .page-subtitle {
          font-size: 1.15rem;
          color: #4a5568;
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.7;
        }

        .search-section {
          margin-bottom: 3rem;
        }

        .search-wrapper {
          position: relative;
          max-width: 600px;
          margin: 0 auto 1rem;
        }

        .search-icon {
          position: absolute;
          left: 1.25rem;
          top: 50%;
          transform: translateY(-50%);
          color: #718096;
          pointer-events: none;
        }

        .search-input {
          width: 100%;
          padding: 1rem 1rem 1rem 3.25rem;
          border: 2px solid #e2e8f0;
          border-radius: 50px;
          font-size: 1rem;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
          background: white;
        }

        .search-input:focus {
          outline: none;
          border-color: #2d5a8c;
          box-shadow: 0 0 0 3px rgba(45, 90, 140, 0.1);
        }

        .results-count {
          text-align: center;
          color: #718096;
          font-size: 0.95rem;
        }

        .glossaire-content {
          display: flex;
          flex-direction: column;
          gap: 3rem;
        }

        .letter-section {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        }

        .letter-heading {
          font-size: 2.5rem;
          color: #2d5a8c;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid rgba(45, 90, 140, 0.2);
          font-weight: 700;
        }

        .terms-list {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        .term-item {
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .term-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .term-title {
          font-size: 1.4rem;
          color: #1a365d;
          margin-bottom: 0.75rem;
          font-weight: 600;
        }

        .term-definition {
          color: #4a5568;
          line-height: 1.8;
          font-size: 1.05rem;
        }

        .no-results {
          text-align: center;
          padding: 4rem 2rem;
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
        }

        .no-results p {
          font-size: 1.15rem;
          color: #718096;
        }

        @media (max-width: 768px) {
          .glossaire-container {
            padding: 2rem 1.5rem;
          }

          .page-title {
            font-size: 2rem;
          }

          .page-subtitle {
            font-size: 1rem;
          }

          .letter-section {
            padding: 1.5rem;
          }

          .letter-heading {
            font-size: 2rem;
          }

          .term-title {
            font-size: 1.2rem;
          }

          .term-definition {
            font-size: 1rem;
          }
        }
      `}</style>
    </main>
  );
};

export default Glossaire;